import React from 'react';
import PropertyGridUtils from '../PropertyGridUtils';

import CodeEditor from './CodeEditor';

export default class CssEditor extends CodeEditor {
    mode = "css"
    render() {
        return super.render();
    }
}

PropertyGridUtils.register("css", (source, propertyGrid) => <CssEditor source={source} propertyGrid={propertyGrid} />);